import React from 'react';

const lazyNamed = (loader, exportName) => {
    const LazyComponent = React.lazy(() =>
        loader().then(module => ({ default: module[exportName] }))
    );

    return props =>
        React.createElement(
            React.Suspense,
            { fallback: React.createElement('div', { style: { padding: 20 } }, 'Chargement de l’admin…') },
            React.createElement(LazyComponent, props)
        );
};

export const LazyUserList = lazyNamed(() => import('./pages/users'), 'UserList');
export const LazyUserEdit = lazyNamed(() => import('./pages/users'), 'UserEdit');
export const LazyUserCreate = lazyNamed(() => import('./pages/users'), 'UserCreate');

export const LazyEventList = lazyNamed(() => import('./pages/events'), 'EventList');
export const LazyEventEdit = lazyNamed(() => import('./pages/events'), 'EventEdit');
export const LazyEventCreate = lazyNamed(() => import('./pages/events'), 'EventCreate');
export const LazyEventShow = lazyNamed(() => import('./pages/events'), 'EventShow');

export const LazyPlaceList = lazyNamed(() => import('./pages/places'), 'PlaceList');
export const LazyPlaceEdit = lazyNamed(() => import('./pages/places'), 'PlaceEdit');
export const LazyPlaceCreate = lazyNamed(() => import('./pages/places'), 'PlaceCreate');
